module.exports = __webpack_public_path__ + "img/sm-oval-3.27d498cf.png";